import { Badge } from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import styles from './LinkedProjectItem.module.scss';
import { Props } from './LinkedProjectItem.types';

const LABEL_COLOR: Record<string, string> = {
  RED: 'red',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  GREEN: 'green',
  BLUE: 'blue',
  PURPLE: 'violet',
  GRAY: 'gray',
};

const STATUS_COLOR: Record<string, string> = {
  IDEA_BOX: 'gray',
  IDEA_TO_VOTE: 'orange',
  PROJECT_VALIDATED: 'teal',
  PROJECT_IN_PROGRESS: 'blue',
  PROJECT_COMPLETED: 'green',
};

const LinkedProjectItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();

  const label = item.metadata?.label as string | undefined;
  const status = (item.metadata?.status as string) ?? 'IDEA_BOX';
  const deadline = item.metadata?.deadline as string | undefined;

  return (
    <div className={styles.container} onClick={onClick}>
      <span
        className={styles.colorBar}
        style={{ backgroundColor: `var(--mantine-color-${LABEL_COLOR[label ?? 'GRAY']}-5)` }}
      />
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {deadline && (
          <span className={styles.subtitle}>{dayjs(deadline).format('DD/MM/YYYY')}</span>
        )}
      </div>
      <Badge size="sm" color={STATUS_COLOR[status] ?? 'gray'}>
        {t(`entityLinks.project.status.${status}`, status)}
      </Badge>
    </div>
  );
};

export default LinkedProjectItem;
